import React, { useState } from "react";
import { NavLink } from "react-router-dom";
interface IStreet {
  name: string;
  id: string;
  debid: string;
}

interface IStreets extends Array<IStreet> {}

const SideBar = (props: { streets: IStreets }) => {
  const [Streets, setStreets] = useState<IStreets | undefined>(undefined);

  React.useEffect(() => {
    if (Streets === undefined) {
      setStreets(props.streets);
    }
  }, []);

  if (Streets !== props.streets) {
    setStreets(props.streets);
  }

  return (
    <section className="sidebar">
      <nav className="mainmenu">
        <h2>Milieustraten</h2>
        <ul>
          {Streets?.map((Street, i) => (
            <li key={i}>
              <NavLink
                key={Street.id}
                className="mainmenu_items"
                activeClassName="active"
                to={"/street/" + Street.id + "/" + Street.debid}
                title={Street.name}
              >
                {Street.name}
              </NavLink>
            </li>
          ))}
        </ul>
        <NavLink className={"logout"} to="/logout">
          Uitloggen
        </NavLink>
      </nav>
    </section>
  );
};
export default SideBar;
